<script setup lang="ts">
import ButtonAll from './ButtonAll.vue'
import useUser from '../../../../../Composables/User/useUser.ts'

const { isReadOnly } = useUser()
</script>
<template>
  <ButtonAll v-if="!isReadOnly" />
  <span v-else></span>
</template>
